[
  {
    "id": 275,
    "uuid": "2f2ec8e2-ac77-45a0-a0f6-b62cf124b493",
    "hitokoto": "如果不能忠于自己的心，胜负又有什么价值呢？",
    "type": "b",
    "from": "塔希里亚故事集",
    "from_who": null,
    "creator": "魅影陌客",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949091",
    "length": 21
  },
  {
    "id": 276,
    "uuid": "c1507f83-9422-448a-87d2-7c6a50203eca",
    "hitokoto": "在茫茫人海中，同样是高中生，同乘7点50分的电车，看着同一片海……那个瞬间不就是如奇迹般的邂逅吗。",
    "type": "b",
    "from": "单恋电车",
    "from_who": null,
    "creator": "冥酱",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949092",
    "length": 49
  },
  {
    "id": 277,
    "uuid": "e31e3a1c-5afe-4424-ad38-6c7081e8ddce",
    "hitokoto": "一起去看星星吧。",
    "type": "b",
    "from": "未来日记",
    "from_who": null,
    "creator": "lies",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949092",
    "length": 8
  },
  {
    "id": 279,
    "uuid": "8e312081-f46c-417c-83af-907ddf94908b",
    "hitokoto": "一定没有问题的！",
    "type": "b",
    "from": "魔卡少女樱",
    "from_who": null,
    "creator": "魅影陌客",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949092",
    "length": 8
  },
  {
    "id": 280,
    "uuid": "fcd9085a-84b4-4137-8360-7297954adfda",
    "hitokoto": "我爱的人也爱着我，对我来说这简直是个奇迹。",
    "type": "b",
    "from": "NANA",
    "from_who": null,
    "creator": "nana酱",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949093",
    "length": 21
  },
  {
    "id": 281,
    "uuid": "32350c90-1cea-410f-a8c4-82c36a380ce9",
    "hitokoto": "你为了你的正义，我为了我的正义。",
    "type": "b",
    "from": "火影忍者",
    "from_who": null,
    "creator": "青媚狐",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949093",
    "length": 16
  },
  {
    "id": 282,
    "uuid": "aef9d1c5-99cc-48fe-bb22-f682490bf0ce",
    "hitokoto": "就算风吹散了冰雪，想念也会留存下来。",
    "type": "b",
    "from": "滑头鬼之孙",
    "from_who": null,
    "creator": "苏陌奕",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949094",
    "length": 18
  },
  {
    "id": 283,
    "uuid": "393542a5-8e0b-4c93-be60-31d4e2347f98",
    "hitokoto": "我的一生，无怨无悔！",
    "type": "b",
    "from": "北斗神拳",
    "from_who": null,
    "creator": "HeYSH",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949095",
    "length": 10
  },
  {
    "id": 284,
    "uuid": "395285eb-4700-417f-8cde-042fe35c2666",
    "hitokoto": "越是困难，越要抬起头，地上可找不到任何希望！",
    "type": "b",
    "from": "Zetman",
    "from_who": null,
    "creator": "世界尽头之海",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949098",
    "length": 22
  },
  {
    "id": 742,
    "uuid": "864cefec-de78-42f3-96b5-7b217e0c7704",
    "hitokoto": "人类总是将世界缩小在自己浅薄的知识范围之内，总是把超越自己理解能力的事物当成威胁自己立场的敌人来对待，非得排斥、驱除、抹杀不可……可是对于同种族的生物，又以肤色、出身来划分阶级贵贱，相互憎恨，相互残杀。",
    "type": "b",
    "from": "恐怖宠物店",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 101
  },
  {
    "id": 758,
    "uuid": "fcfe3b0d-5214-4b33-b330-8201a407a86f",
    "hitokoto": "我本来不想使出这一招的",
    "type": "b",
    "from": "少年JUMP",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 11
  },
  {
    "id": 767,
    "uuid": "e6b1e953-aaa5-4deb-9131-fe3db992dd39",
    "hitokoto": "我们也许再也不会见面了吧，因此我绝对不会忘了你的声音，你的眼眸，与你一起看到过的所有的景色，以及，与你一起度过的那个耀眼的夏天。",
    "type": "b",
    "from": "草莓100%",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 64
  },
  {
    "id": 794,
    "uuid": "b8a9fa4f-1fc1-430d-aeed-49a8e99f101f",
    "hitokoto": "在茫茫人海中，同样是高中生，同乘7点50分的电车，看着同一片海…那个瞬间不就是如奇迹般的邂逅吗。",
    "type": "b",
    "from": "单恋电车",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 48
  },
  {
    "id": 847,
    "uuid": "603f4db8-e69f-4b2a-9dc7-72c9948ee768",
    "hitokoto": "不管你说再多的慌，只有自己的内心，是无法欺骗的啊。",
    "type": "b",
    "from": "七大罪",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 25
  },
  {
    "id": 850,
    "uuid": "49dbdaef-2b7f-446f-ab99-7ff61d5939bc",
    "hitokoto": "爱,其实很简单，困难的是去接受它。",
    "type": "b",
    "from": "通灵王",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 17
  },
  {
    "id": 859,
    "uuid": "6c249d89-e177-432d-add6-65f56a46c58a",
    "hitokoto": "Choose , and choose wisely . Or others shall choose for you .",
    "type": "b",
    "from": "夜魔侠",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 61
  },
  {
    "id": 935,
    "uuid": "fa2dd5f5-d593-42ed-b024-13a059b5bcf5",
    "hitokoto": "其实美丽的故事都是没有结局的，只因为它没有结局所以才会美丽。",
    "type": "b",
    "from": "萤火之森",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 30
  },
  {
    "id": 962,
    "uuid": "e5dfbf51-3438-4c4d-8773-d94defaee0e8",
    "hitokoto": "我和你，可以做朋友吗？",
    "type": "b",
    "from": "声の形",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1479435961",
    "length": 11
  },
  {
    "id": 977,
    "uuid": "51547002-c471-49c8-b5f8-90daa9871a36",
    "hitokoto": "今后无论发生什么事也好，这个左手上的⋯⋯都是同伴的记号！",
    "type": "b",
    "from": "海贼王",
    "from_who": "尾田荣一郎",
    "creator": "1102058350",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 28
  },
  {
    "id": 981,
    "uuid": "1fceb6ad-a44f-47f0-bd3f-66d65afddd06",
    "hitokoto": "总有一天一定会……有站在你身边与你展望着同样的未来的伙伴出现。",
    "type": "b",
    "from": "电波教师",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 31
  },
  {
    "id": 989,
    "uuid": "eaf5f102-7957-4f6b-a037-20bdd36fe365",
    "hitokoto": "吟唱幸福的歌谣，令少女沉醉向往。童话堕入黑夜，是谎言还是幻梦，无声终结",
    "type": "b",
    "from": "穿越西元3000后",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 35
  },
  {
    "id": 1013,
    "uuid": "a280f1ba-bb6d-4d85-a6a2-c07698895c2b",
    "hitokoto": "最最好的，与最最痛苦的，是一样的。",
    "type": "b",
    "from": "文学与少女",
    "from_who": "玛德莱娜",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 17
  },
  {
    "id": 1023,
    "uuid": "a71b322e-98d1-4366-8d63-5d093f74c2d8",
    "hitokoto": "是不是现在踏出这一步，下决定的是他。",
    "type": "b",
    "from": "电波教师",
    "from_who": null,
    "creator": "2416790970",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 18
  },
  {
    "id": 1027,
    "uuid": "455eefad-4a6e-4e97-83af-0d1b2903f6be",
    "hitokoto": "跌跌撞撞的成长，又美又疼才是本质。",
    "type": "b",
    "from": "哥斯拉不说话",
    "from_who": "夏达",
    "creator": "1102058350",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 17
  },
  {
    "id": 1029,
    "uuid": "b1bd7e51-dd0c-44bf-9cf8-9bb43088e260",
    "hitokoto": "管他不会说话还是不会交流，只要不放弃就一定能把意思传达给对方。",
    "type": "b",
    "from": "学园救援团",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 31
  },
  {
    "id": 1031,
    "uuid": "b4aa9392-7926-4934-b0ea-fb9462ec35fe",
    "hitokoto": "失去故土的花朵，回不去，却也离不开。",
    "type": "b",
    "from": "长歌行",
    "from_who": "夏达",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 18
  },
  {
    "id": 1035,
    "uuid": "0182b012-d353-40fd-bad9-be687ee1028d",
    "hitokoto": "那天，我听到了种子破土的声音，又细微又坚定。",
    "type": "b",
    "from": "子不语",
    "from_who": "夏达",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 22
  },
  {
    "id": 1043,
    "uuid": "5f5866ff-55a5-4a0b-809d-0b444cb3dca4",
    "hitokoto": "身为冒险者，如果安静的老死在床上，那简直就是耻辱！",
    "type": "b",
    "from": "恶魔法则",
    "from_who": "跳舞",
    "creator": "942903628",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 25
  },
  {
    "id": 1200,
    "uuid": "949df85d-bbc6-45a6-bf8d-2c0d39a3e9db",
    "hitokoto": "人在遇到才能时抱有的感情有三个，『感叹』 『恐怖』还有『嫉妒』",
    "type": "b",
    "from": "轮回的花瓣",
    "from_who": null,
    "creator": "zivi",
    "creator_uid": 450,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1499180773",
    "length": 31
  },
  {
    "id": 1318,
    "uuid": "567113c1-7201-4a71-96cf-02b5eaac07fd",
    "hitokoto": "爱与友情以及勇气改变不了一个人，只有受伤才能让人成长",
    "type": "b",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "小埋233",
    "creator_uid": 910,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512889263",
    "length": 26
  },
  {
    "id": 1319,
    "uuid": "8aa6ca84-d375-4171-a330-189fd3d7cd68",
    "hitokoto": "猫是可爱的，狼是很帅的。就是说，孤独又可爱又帅。",
    "type": "b",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "小埋233",
    "creator_uid": 910,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512889521",
    "length": 24
  },
  {
    "id": 1322,
    "uuid": "75c4bc61-1285-43cc-a2bb-744ba0cb50de",
    "hitokoto": "世界上的男人 80%都抱有“她是不是喜欢我？”这样的想法而活 正因为如此 我才需要告诫自己 「永远都不要以为妹子喜欢你」",
    "type": "b",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "小埋233",
    "creator_uid": 910,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512889227",
    "length": 60
  },
  {
    "id": 1325,
    "uuid": "9bd60ed7-e50e-4a00-a07f-b8168e5c3cfb",
    "hitokoto": "孤独的人不会伤害别人，只会不断地伤害自己罢了。",
    "type": "b",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "小埋233",
    "creator_uid": 910,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512889085",
    "length": 23
  },
  {
    "id": 1327,
    "uuid": "484cf2b5-e276-4b8a-9c0e-0a718d10e40b",
    "hitokoto": "温柔正确的人总是难以生存，因为这世界既不温柔，也不正确",
    "type": "b",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "小埋233",
    "creator_uid": 910,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512889040",
    "length": 27
  },
  {
    "id": 1349,
    "uuid": "7305461e-1962-4186-ad31-6730ded3e74a",
    "hitokoto": "末将于禁，愿为曹家世代赴汤蹈火。",
    "type": "b",
    "from": "镇魂街",
    "from_who": null,
    "creator": "死木芽",
    "creator_uid": 1033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1515592778",
    "length": 16
  },
  {
    "id": 1372,
    "uuid": "40107697-1987-42dc-af3f-abb080b98da6",
    "hitokoto": "和你们这些少爷不同，我们光是活着就竭尽全力了。",
    "type": "b",
    "from": "银魂",
    "from_who": null,
    "creator": "风亦扬",
    "creator_uid": 1124,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1517664113",
    "length": 23
  },
  {
    "id": 3617,
    "uuid": "4c4433ff-3b21-4763-b0ef-93086d1286c4",
    "hitokoto": "不幸的是我们等了那么多年，幸运的我们那么多年过去还一直在一起",
    "type": "b",
    "from": "薄荷之夏",
    "from_who": null,
    "creator": "lausanne",
    "creator_uid": 1398,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523781497",
    "length": 30
  },
  {
    "id": 3876,
    "uuid": "73e5ccfa-719a-4552-9f62-219e81e15cfa",
    "hitokoto": "人，百年一世；龙，百年一岁。君生吾已老，君未变，而吾已老。",
    "type": "b",
    "from": "妖怪名单",
    "from_who": null,
    "creator": "老猫",
    "creator_uid": 2061,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536884047",
    "length": 29
  },
  {
    "id": 3944,
    "uuid": "fde6b84c-6ab1-4219-879d-923be92117f0",
    "hitokoto": "我今天就是要带她走，我看哪个敢拦我。",
    "type": "b",
    "from": "刺客伍六七",
    "from_who": null,
    "creator": "CSW",
    "creator_uid": 2134,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538619959",
    "length": 18
  },
  {
    "id": 3961,
    "uuid": "f12f44e1-5339-4213-8d3b-6ae54a1e2002",
    "hitokoto": "小鸟......是无法追上飞龙的。",
    "type": "b",
    "from": "加油大魔王",
    "from_who": null,
    "creator": "礼乐",
    "creator_uid": 2215,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540040803",
    "length": 17
  },
  {
    "id": 3962,
    "uuid": "4dc96239-45b8-40db-b6eb-c7f96a29d4d3",
    "hitokoto": "我命令你，喜欢我！",
    "type": "b",
    "from": "加油大魔王",
    "from_who": null,
    "creator": "礼乐",
    "creator_uid": 2215,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540040875",
    "length": 9
  },
  {
    "id": 3963,
    "uuid": "8dba1467-7124-4a1e-95be-b5c2b212029b",
    "hitokoto": "我只是不想再失去他——哪怕是仅存在一瞬的幻影！",
    "type": "b",
    "from": "加油大魔王",
    "from_who": null,
    "creator": "礼乐",
    "creator_uid": 2215,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540041044",
    "length": 23
  },
  {
    "id": 3964,
    "uuid": "3a066d73-c382-480a-818c-edd6e799e594",
    "hitokoto": "身为魔物，难道就没生存的价值了吗？是谁给了人类如此傲慢的资格......",
    "type": "b",
    "from": "加油大魔王",
    "from_who": null,
    "creator": "礼乐",
    "creator_uid": 2215,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540041262",
    "length": 36
  },
  {
    "id": 3996,
    "uuid": "0387e3ff-67b5-402c-b3cd-92c7c22e0d73",
    "hitokoto": "伤口只要闭上眼就会消失吗？悲鸣只要听不见就不存在了吗？就算能逃到世界的边缘，也无法逃避自己内心的声音。",
    "type": "b",
    "from": "加油大魔王",
    "from_who": null,
    "creator": "礼乐",
    "creator_uid": 2215,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540041579",
    "length": 51
  },
  {
    "id": 3997,
    "uuid": "a09138ba-7b95-44eb-a69e-41063a987c1a",
    "hitokoto": "哪怕这一路上只有苦难和悲伤，只有悔恨和绝望——你也会坚持自己的选择吗？！",
    "type": "b",
    "from": "加油大魔王",
    "from_who": null,
    "creator": "礼乐",
    "creator_uid": 2215,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540041709",
    "length": 36
  },
  {
    "id": 4060,
    "uuid": "b5c7f1d4-a59d-4c62-b897-4668f7ede104",
    "hitokoto": "憧憬是距离理解最遥远的感情",
    "type": "b",
    "from": "BLEACH",
    "from_who": null,
    "creator": "diazynez",
    "creator_uid": 2418,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543638763",
    "length": 13
  },
  {
    "id": 4061,
    "uuid": "b0bd791f-d86d-4b20-834a-e8c11a5976f7",
    "hitokoto": "不要轻易的口出狂言，那样只会透露出你的软弱。",
    "type": "b",
    "from": "BLEACH",
    "from_who": null,
    "creator": "diazynez",
    "creator_uid": 2418,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543638734",
    "length": 22
  },
  {
    "id": 4076,
    "uuid": "9da9d8fb-c127-4ec9-9ad4-c2dc032fe977",
    "hitokoto": "如果我是雨的话，也能像连接那永远都不将交汇的天空和大地一样，去连接某个人的心吗。",
    "type": "b",
    "from": "井上织姬",
    "from_who": null,
    "creator": "diazynez",
    "creator_uid": 2418,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543638703",
    "length": 40
  },
  {
    "id": 4099,
    "uuid": "fe495f3b-8ca5-4ba0-804c-82cf39bd9673",
    "hitokoto": "不要太小看人类了！",
    "type": "b",
    "from": "加油大魔王",
    "from_who": null,
    "creator": "礼乐",
    "creator_uid": 2215,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540043259",
    "length": 9
  },
  {
    "id": 4128,
    "uuid": "6ab077e8-7a89-4492-9e98-02cf8f23ffe4",
    "hitokoto": "我又不是因为你们的评价才去当的英雄，是因为我想当才去当的",
    "type": "b",
    "from": "一拳超人",
    "from_who": null,
    "creator": "二十一",
    "creator_uid": 2361,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542691773",
    "length": 28
  },
  {
    "id": 4147,
    "uuid": "a40a6c99-7efc-4b34-85f4-faa840283c05",
    "hitokoto": "如果我手上没有剑，我就无法保护你；如果我一直握着剑，我就无法抱紧你",
    "type": "b",
    "from": "久保带人",
    "from_who": null,
    "creator": "diazynez",
    "creator_uid": 2418,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543638641",
    "length": 33
  },
  {
    "id": 4148,
    "uuid": "b1574dc2-9d8e-427d-b578-1d8da918b337",
    "hitokoto": "憧憬是距离理解最遥远的感情",
    "type": "b",
    "from": "蓝染惣右介",
    "from_who": null,
    "creator": "diazynez",
    "creator_uid": 2418,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543638668",
    "length": 13
  },
  {
    "id": 4265,
    "uuid": "2f4db379-d084-429a-9575-f82474cf0eed",
    "hitokoto": "我之所以想变强，是为了活得轻松写意。",
    "type": "b",
    "from": "一拳超人",
    "from_who": null,
    "creator": "逗逼领主",
    "creator_uid": 1292,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549112027",
    "length": 18
  },
  {
    "id": 4266,
    "uuid": "f10ebdc3-8488-492a-aa3c-25d1f47be62f",
    "hitokoto": "强大使人快乐。",
    "type": "b",
    "from": "一拳超人",
    "from_who": null,
    "creator": "逗逼领主",
    "creator_uid": 1292,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549115751",
    "length": 7
  },
  {
    "id": 4559,
    "uuid": "3f97cf57-6abd-46eb-a501-fc7f49aa2ab0",
    "hitokoto": "我们是学生，学生就要有学生的样子。",
    "type": "b",
    "from": "JOJO的奇妙冒险",
    "from_who": null,
    "creator": "你家炸了",
    "creator_uid": 3557,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1564109075",
    "length": 17
  },
  {
    "id": 4582,
    "uuid": "3e5ec9cc-4b67-46dc-ab65-bfa71286f352",
    "hitokoto": "天使也好，恶魔也罢，不过是另一个世界的虚幻。现实也好，幻想也罢，不过是自己不敢面对真理的避风港。",
    "type": "b",
    "from": "原创",
    "from_who": null,
    "creator": "月下无梦灬",
    "creator_uid": 3709,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566474988",
    "length": 48
  },
  {
    "id": 4714,
    "uuid": "ddd333b4-c165-4769-b6d6-b65d975d056e",
    "hitokoto": "憧憬，是距离了解最遥远的一种感情。",
    "type": "b",
    "from": "BLEACH",
    "from_who": null,
    "creator": "C20211711LJS",
    "creator_uid": 4101,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571495702",
    "length": 17
  },
  {
    "id": 5027,
    "uuid": "18808896-5b66-4aeb-aae9-12618d9820a7",
    "hitokoto": "吾心吾行澄如明镜，所作所为皆为正义。",
    "type": "b",
    "from": "JOJO的奇妙冒险",
    "from_who": "飙马野郎",
    "creator": "Joseph Jostar",
    "creator_uid": 4527,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1577005300",
    "length": 18
  },
  {
    "id": 5437,
    "uuid": "e6dc7823-6f3b-40c3-9c54-c3c646a1f7fc",
    "hitokoto": "我们总会为了昨天的伤害而痛苦，但请求你不要把今天埋上阴影，我们不要为了伤害你的人而痛苦的活着，记住那些爱你的人，为了她们努力的去活好每一个今天吧！",
    "type": "b",
    "from": "次元战争·红龙",
    "from_who": "童梦心",
    "creator": "Rain",
    "creator_uid": 5767,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585888524",
    "length": 73
  },
  {
    "id": 5439,
    "uuid": "c27b5554-6d5d-4146-80c8-5d2fa8538e7b",
    "hitokoto": "任尘世繁华，唯有守护你的一切，才是我此生唯一的使命。",
    "type": "b",
    "from": "次元战争·红龙",
    "from_who": "初启源",
    "creator": "Rain",
    "creator_uid": 5767,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586109411",
    "length": 26
  },
  {
    "id": 5963,
    "uuid": "b25ebe3d-d031-493c-a129-61ba3b7c0a23",
    "hitokoto": "此时此刻的咱啊，能和汝在一起，是最幸福的了。",
    "type": "b",
    "from": "狼与香辛料",
    "from_who": "支仓冻砂",
    "creator": "人活着就是为了贤狼赫萝",
    "creator_uid": 5896,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586916630",
    "length": 22
  },
  {
    "id": 6036,
    "uuid": "7b99a3c5-5b91-4cf9-a2f3-9eaa4b535758",
    "hitokoto": "愿时光能缓，愿故人不散！",
    "type": "b",
    "from": "我们仍未知道那天所看见的花的名字",
    "from_who": null,
    "creator": "陌人犹未归",
    "creator_uid": 5933,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587104717",
    "length": 12
  },
  {
    "id": 6052,
    "uuid": "f03a1c18-e1d1-43fd-b826-915c03b78cf6",
    "hitokoto": "如果有一个喜欢你的人出现，一定不要凶她哦！",
    "type": "b",
    "from": "次元战争·红龙",
    "from_who": "瑶瑶",
    "creator": "Rain",
    "creator_uid": 5767,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1587546774",
    "length": 21
  },
  {
    "id": 6243,
    "uuid": "88e25418-a6a3-404a-818b-a8f3c31ba0f9",
    "hitokoto": "人总是贪婪的，就像最开始，我也只是想知道你的名字。",
    "type": "b",
    "from": "你的名字",
    "from_who": "新海诚",
    "creator": "世见",
    "creator_uid": 6367,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591148603",
    "length": 25
  },
  {
    "id": 6280,
    "uuid": "f3426c70-cc0f-4c26-88b5-63194b653eb2",
    "hitokoto": "这一路走来我都做得很好，我是能干的人，今天也是，从今往后也是，无论有多挫折。",
    "type": "b",
    "from": "鬼灭之刃",
    "from_who": null,
    "creator": "夕",
    "creator_uid": 6429,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591841930",
    "length": 38
  },
  {
    "id": 6665,
    "uuid": "d0a7f63d-d4d1-48fc-9726-fa99cfc402ea",
    "hitokoto": "军人天生就舍弃了战斗的意义！",
    "type": "b",
    "from": "机动战士高达00",
    "from_who": "格拉汉姆",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604587434",
    "length": 14
  },
  {
    "id": 6668,
    "uuid": "4e854a10-9603-423b-be31-1c71773c2b85",
    "hitokoto": "两个人从监狱的窗户往外看，一个看见了土地，一个看见了星星。",
    "type": "b",
    "from": "jojo的奇妙冒险",
    "from_who": "空条徐伦",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604752220",
    "length": 29
  },
  {
    "id": 6678,
    "uuid": "0ca5d0e4-0715-4c9c-af2d-cfbae544e7d4",
    "hitokoto": "富江有天使的脸孔，但其实她是个恶魔，不，恶魔也比她要好一点。",
    "type": "b",
    "from": "富江",
    "from_who": "伊藤润二",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604753846",
    "length": 30
  },
  {
    "id": 6968,
    "uuid": "1940ce47-374b-4aa0-9a8a-3d94503239ea",
    "hitokoto": "所有登峰造极之人最终都会抵达同一个终点，哪怕时代变迁，哪怕所经历的路途千差万别，他们最终都会抵达同样的终点。",
    "type": "b",
    "from": "鬼灭之刃",
    "from_who": null,
    "creator": "青医.",
    "creator_uid": 8323,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611562557",
    "length": 54
  },
  {
    "id": 7000,
    "uuid": "6c174117-60f4-4777-8b21-9b3de34a58ec",
    "hitokoto": "如果能实现我的一个愿望，我希望……世界上所有弹药都变成棉花糖。然后用棉花糖填满整个地球，让人类沉浸在软绵绵的感觉中灭亡。",
    "type": "b",
    "from": "DEAD DEAD DEAMON'S DEDEDEDE DESTRUCTION",
    "from_who": "中川凰兰",
    "creator": "如月三穗",
    "creator_uid": 8351,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612200722",
    "length": 60
  },
  {
    "id": 7170,
    "uuid": "e0a29ec8-608a-4f0b-8960-07b3ef4dfb70",
    "hitokoto": "我们的学生会长，比高达还强。",
    "type": "b",
    "from": "旋风管家",
    "from_who": "春风千樱",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614946047",
    "length": 14
  },
  {
    "id": 7212,
    "uuid": "c1229912-4577-4fec-a052-03e527055a50",
    "hitokoto": "不敢打开信封啊。因为，打开了就结束了啊。",
    "type": "b",
    "from": "旋风管家",
    "from_who": "三千院凪",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1616759569",
    "length": 20
  },
  {
    "id": 7339,
    "uuid": "fbbcd59d-9f8b-40a7-b321-2cf1d64032fb",
    "hitokoto": "愿被你所见的，是我完美的模样；愿被你所爱的，是我真实的模样；愿你能装作视而不见的，是我在两者间徘徊不定的模样。",
    "type": "b",
    "from": "龙与魔女",
    "from_who": "久保带人",
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1621920368",
    "length": 55
  },
  {
    "id": 7342,
    "uuid": "cb4eda79-40c8-414f-b601-427ea7d13030",
    "hitokoto": "嗯呐......软绵绵的人偶，来治愈你们的哟。",
    "type": "b",
    "from": "来自深渊",
    "from_who": "娜娜奇",
    "creator": "娜娜奇",
    "creator_uid": 9423,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1622370925",
    "length": 23
  },
  {
    "id": 7431,
    "uuid": "1e2be754-0d6b-47cf-9a9e-69dcb036c152",
    "hitokoto": "行ってらっしゃい、きよつけてね。愿わくその先に光がありますように… 走好，路上小心。愿你们的前方善存光明......",
    "type": "b",
    "from": "约定的梦幻岛",
    "from_who": "伊莎贝拉",
    "creator": "如月三穗",
    "creator_uid": 8351,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1618745301",
    "length": 58
  },
  {
    "id": 7472,
    "uuid": "fb068668-454f-43c7-a74a-d3787efb22a9",
    "hitokoto": "只有分离后才能懂的事，却没有了感慨的时间。",
    "type": "b",
    "from": "宝石之国",
    "from_who": "波尔茨",
    "creator": "朱佳熠",
    "creator_uid": 9963,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1628008477",
    "length": 21
  }
]